import React, { useEffect, useState } from 'react'
import Card from '../../controls/Card'
import { GetAll } from '../../../configurations/crud/doctorsFastNoteCurd'
import { MdErrorOutline } from 'react-icons/md'
import { useToast } from '../../controls/Toast/ToastService'
import { FaBell, FaDisease } from "react-icons/fa";
import { FaCircleInfo } from 'react-icons/fa6'
import { GetEDoctorStatusName } from '../../../configurations/enums/EDoctorStatus'
import * as opdCentersCrud from '../../../configurations/crud/opdCentersCrud'
import { useParams } from 'react-router-dom'
import ReceptionEmergency from './ReceptionEmergency'
import ReceptionConfirmed from './ReceptionConfirmed'
import ReceptionRegistered from './ReceptionRegistered'
import moment from 'moment'
import * as opdRegisteredCrud from '../../../configurations/crud/opdRegisteredCrud'
import { getLoginInfo } from '../../../configurations/auth/getLoginInfo'
import PatientHistory from './PatientHistory'
import ContainerTwo from '../../base/ContainerTwo'
import { HubConnectionBuilder, LogLevel } from '@microsoft/signalr';
import { LIVE_URL } from '../../../configurations/initUrls'
import WarningPopUp from './WarningPopUp'
import DaillyShortReport from '../report/DaillyShortReport'
import { VscDebugDisconnect } from "react-icons/vsc";
import LoadingContainer from '../../controls/LoadingContainer'
import { allowSleep, keepAwake } from '../../../configurations/native/screenTime'
import { useKeepAwake } from 'react-keep-awake';
import useGlobalLoader from '../../../configurations/useGlobalLoader'
import { PiPlugsConnectedFill } from 'react-icons/pi'

export default function DoctorDisplay() {
  const { start, end } = useGlobalLoader()
  const [fastNotesData, setFastNotesData] = useState([])
  const [loding, setLoding] = useState(false)
  const [doctorStatus, setDoctorStatus] = useState(1);
  const { centerid } = useParams()
  const [viewUsers, setViewUsers] = useState(1);
  const [centerData, setCenterData] = useState();
  const [currentData, setCurrentData] = useState();
  const toast = useToast()
  const loginInfo = getLoginInfo()
  const [isOpenUnavailable, setIsOpenUnavailable] = useState(false)
  const [nextPatientData, setNextPatientData] = useState();
  const [note, setNote] = useState();
  const [isOpenPop, setIsOpenPop] = useState(false)
  const [lodingCrud, setLodingCrud] = useState(false)
  const [isDailyUpdate, setIsDailyUpdate] = useState(0)
  useKeepAwake()
  useEffect(() => {
    keepAwake()
    return () => {
      allowSleep()
    }
  }, [])


  ///Chat Start Block\
  const [connection, setConnection] = useState();
  const [messages, setMessages] = useState([]);
  const [users, setUsers] = useState([]);
  const joinroom = async (user, room) => {
    try {
      const connection = new HubConnectionBuilder()
        .withUrl(LIVE_URL)
        .configureLogging(LogLevel.Information)
        .build();

      connection.on("UsersInRoom", (users) => {
        setUsers(users);
      });

      connection.on("ReceiveMessage", (user, message) => {
        console.log(message)
        switch (message) {
          case "1": { GetCenterDetails(); break; }
          case "2": { GetPatientInTheCabin(); setCurrentData(); setIsDailyUpdate(pre => pre + 1); break; }
          case "3": { GetPatientInTheCabin(); setCurrentData(); break; }
          case "4": { GetPatientInTheCabin(); setCurrentData(); setIsDailyUpdate(pre => pre + 1); break; }
        }
        setMessages(messages => [...messages, { user, message }]);
      });

      connection.onclose(e => {
        setConnection();
        setMessages([]);
        setUsers([]);
      })

      connection.onclose(e => {
        setConnection();
        setMessages([]);
      });

      await connection.start();
      await connection.invoke("JoinRoom", { user, room });
      setConnection(connection);

    } catch (e) {
      console.log(e);
    }
  }

  const sendMessage = async (message) => {
    try {
      await connection.invoke("SendMessage", message);
    } catch (e) {
      console.log(e);
    }
  }

  const closeConnection = async () => {
    try {
      await connection.stop();
    } catch (e) {
      console.log(e);
    }
  }

  ///Chat End Block
  const reConnect = () => {
    joinroom(loginInfo.userName + "_" + centerid + "_Doctor", loginInfo.userName + "_" + centerid)
    toast.open("Connected", <VscDebugDisconnect />, "success")
  }

  useEffect(() => {
    joinroom(loginInfo.userName + "_" + centerid + "_Doctor", loginInfo.userName + "_" + centerid)
    GetFastNotes()
    GetCenterDetails()
    GetPatientInTheCabin()
    GetPatientWhoNext()
  }, [])

  const GetFastNotes = () => {
    setLoding(true)
    start()
    GetAll().then(res => {
      let mdata = res.data
      if (mdata.result.succeeded) {
        setFastNotesData(mdata.data)
      } else {
        setFastNotesData([])
        //toast.open(mdata.result.message, <MdErrorOutline />, "danger")
      }
      setLoding(false)
      end()
    }).catch(errors => {
      setFastNotesData([])
      //toast.open(errors, <MdErrorOutline />, "danger")
      setLoding(false)
      end()
    })
  }

  const GetDoctorChangeStatus = (s) => {
    setLoding(true)
    start()
    opdCentersCrud.DoctorChangeStatus({
      Status: s,
      Id: centerid
    }).then(res => {
      let mdata = res.data
      if (mdata.succeeded) {
        setDoctorStatus(s)
        sendMessage("1")
        toast.open("Doctor is " + GetEDoctorStatusName(s), <FaCircleInfo />, "info")
      } else {
        toast.open(mdata.result.message, <MdErrorOutline />, "danger")
      }
      setLoding(false)
      end()
    }).catch(errors => {
      toast.open(errors, <MdErrorOutline />, "danger")
      setLoding(false)
      end()
    })
  }

  const GetCenterDetails = () => {
    setLoding(true);
    start()
    opdCentersCrud.GetById(centerid)
      .then((res) => {
        let mdata = res.data;
        if (mdata.result.succeeded) {
          setDoctorStatus(mdata.data.doctorStatus)
          setCenterData(mdata.data);
        } else {
          setCenterData();
          // toast.open(mdata.result.message, <MdErrorOutline />, "danger");
        }
        setLoding(false);
        end()
      })
      .catch((errors) => {
        setCenterData();
        // toast.open(errors, <MdErrorOutline />, "danger");
        setLoding(false);
        end()
      });
  }

  const GetPatientInTheCabin = () => {
    setLoding(true)
    start()
    opdRegisteredCrud.GetPatientInTheCabin({
      DoctorId: getLoginInfo.doctorId,
      CenterId: centerid
    }).then(res => {
      let mdata = res.data
      if (mdata.result.succeeded) {
        setCurrentData(mdata.data)
      } else {
        setCurrentData()
        // toast.open(mdata.result.message, <MdErrorOutline />, "danger")
      }
      setLoding(false)
      end()
    }).catch(errors => {
      setCurrentData()
      // toast.open(errors, <MdErrorOutline />, "danger")
      setLoding(false)
      end()
    })
  }

  const PatientUnavailable = () => {
    setLoding(true)
    start()
    opdRegisteredCrud.PatientUnavailable({
      CenterId: centerid,
      Id: currentData.id
    }).then(res => {
      let mdata = res.data
      if (mdata.result.succeeded) {
        setCurrentData(mdata.data)
        GetPatientWhoNext()
        sendMessage("3")
        sendMessage("5")
        setIsOpenUnavailable(false)
      } else {
        toast.open(mdata.result.message, <MdErrorOutline />, "danger")
        setIsOpenUnavailable(false)
      }
      setLoding(false)
      end()
    }).catch(errors => {
      toast.open(errors, <MdErrorOutline />, "danger")
      setLoding(false)
      end()
      setIsOpenUnavailable(false)
    })
  }

  const GetPatientWhoNext = () => {
    setLoding(true)
    start()
    try {
      opdRegisteredCrud.GetPatientWhoNext({
        DoctorId: loginInfo.doctorId,
        CenterId: centerid
      }).then(res => {
        let mdata = res.data
        if (mdata.result.succeeded) {
          setNextPatientData(mdata.data)
        } else {
          setNextPatientData()
          // toast.open(mdata.result.message, <MdErrorOutline />, "danger")
        }
        setLoding(false)
        end()
      }).catch(errors => {
        setNextPatientData()
        // toast.open(errors, <MdErrorOutline />, "danger")
        setLoding(false)
        end()
      })
    }
    catch (error) {
      alert(error)
    }
  }

  const NextPatient = () => {
    setLoding(true)
    start()
    opdRegisteredCrud.NextPatient({
      CenterId: centerid,
      Note: note
    }).then(res => {
      let mdata = res.data
      if (mdata.result.succeeded) {
        setCurrentData(mdata.data)
        GetPatientWhoNext()
        sendMessage("2")
        sendMessage("5")
        setIsOpenPop(false)
      } else {
        toast.open(mdata.result.message, <MdErrorOutline />, "danger")
        setIsOpenPop(false)
      }
      setLoding(false)
      end()
    }).catch(errors => {
      toast.open(errors, <MdErrorOutline />, "danger")
      setLoding(false)
      end()
      setIsOpenPop(false)
    })
  }

  return (
    <ContainerTwo>
      <div class="my-2"></div>
      <DaillyShortReport refresh={isDailyUpdate} />
      <div class=" flex flex-col md:flex-row" >
        {loding ?
          <div className='w-full'>
            <Card isBorder={true} isBack={true} title="Doctor"  >
              <LoadingContainer text="Please wait..." />
            </Card>
          </div>
          :
          currentData && !loding ?
            <>
              <div class="md:w-7/12 " >
                <Card isBorder={true} isBack={true} title={<div className='w-full flex items-center justify-between'><span>{centerData && (centerData.centerName + " / " + moment(centerData.opdStartTime).format("LT") + "-" + moment(centerData.opdEndTime).format("LT"))}</span><span><button onClick={reConnect} title='Reconnect' className='btn-success'><PiPlugsConnectedFill /></button></span></div>}  >

                  <div className='fixed bottom-4 left-4'>
                    <button className='rounded-full shadow-xl p-3 bg-slate-200' onClick={() => sendMessage("5")}><FaBell className='hover:text-green-500 active:text-green-600' size="50" />
                    </button>
                    <div class="shadow-xl ms-2 px-3.5 py-2 hover:bg-red-600 active:bg-red-700 bg-red-500 text-white rounded-3xl rounded-tl-none justify-start  items-center gap-3 inline-flex">
                      <button onClick={() => sendMessage("25")}>
                        Call EMERGENCY!
                      </button>
                    </div>

                  </div>
                  <div class="text-gray-700">
                    <div class="flex items-center justify-between text-2xl">
                      <div class="px-4 py-2 font-semibold  hidden sm:flex">
                        <button type="button" onClick={(e) => setViewUsers(1)} class={(viewUsers == 1 ? "bg-blue-500" : "bg-gray-400") + " rounded-l-lg px-4 py-2 text-sm font-semibold text-white  border-gray-200 hover:bg-blue-400 focus:z-10 focus:ring-2 focus:ring-blue-500 active:bg-blue-600"}>
                          Patient
                        </button>
                        <button type="button" onClick={(e) => setViewUsers(2)} class={(viewUsers == 2 ? "bg-green-500" : "bg-gray-400") + " px-4 py-2 text-sm font-semibold text-white  border-gray-200 hover:bg-green-400 focus:z-10 focus:ring-2 focus:ring-green-500 active:bg-green-600"}>
                          Registered
                        </button>
                        <button type="button" onClick={(e) => setViewUsers(3)} class={(viewUsers == 3 ? "bg-green-500" : "bg-gray-400") + " px-4 py-2 text-sm font-semibold text-white  border-gray-200 hover:bg-green-400 focus:z-10 focus:ring-2 focus:ring-green-500 active:bg-green-600"}>
                          Confirmed
                        </button>
                        <button type="button" onClick={(e) => setViewUsers(4)} class={(viewUsers == 4 ? "bg-red-500" : "bg-gray-400") + " rounded-r-lg px-4 py-2 text-sm font-semibold text-white  border-gray-200 hover:bg-red-400 focus:z-10 focus:ring-2 focus:ring-red-500 active:bg-red-600"}>
                          Emergency
                        </button>

                      </div>
                      <button type="button" onClick={PatientUnavailable}
                        class="rounded-lg px-6 py-2 ml-16 mt-2 text-sm font-medium text-white bg-orange-500 border-gray-200 hover:bg-orange-400 focus:z-10 focus:ring-2 focus:ring-orange-500 active:bg-orange-600">
                        Unavailable
                      </button>
                    </div>
                  </div>
                  {viewUsers == 1 &&
                    currentData && <PatientHistory currentData={currentData} />
                  }
                  {viewUsers == 2 &&
                    <ReceptionRegistered isActive={viewUsers == 2} searchTerm="" isSearch={0} />
                  }
                  {viewUsers == 3 &&
                    <ReceptionConfirmed isActive={viewUsers == 3} searchTerm="" isSearch={0} />
                  }
                  {viewUsers == 4 &&
                    <ReceptionEmergency isActive={viewUsers == 4} searchTerm="" isSearch={0} />
                  }

                </Card>
              </div>
              <div class="m-2"></div>
              <div class="md:w-5/12" >
                <Card isBorder={true} >
                  <div class="text-gray-700">
                    <div class="overflow-y-scroll text-2xl">
                      <ul class="h-[587px] divide-y divide-gray-200">
                        <li class="py-1">
                          <div class=" mb-2 flex items-center justify-evenly space-x-2 min-w-0">
                            <p class="text-gray-900 truncate ">
                              <button type="button" onClick={() => GetDoctorChangeStatus(1)} class={(doctorStatus == 1 ? "bg-green-500" : "bg-gray-400") + " px-4 py-2 text-sm font-semibold text-white  border-gray-200 hover:bg-green-400 focus:z-10 focus:ring-2 focus:ring-green-500 active:bg-green-600 rounded-l-lg"}>
                                In The Cabin
                              </button>
                              <button type="button" onClick={() => GetDoctorChangeStatus(4)} class={(doctorStatus == 4 ? "bg-orange-500" : "bg-gray-400") + " px-4 py-2 text-sm font-medium text-white  border-gray-200 hover:bg-orange-400 focus:z-10 focus:ring-2 focus:ring-orange-500 active:bg-orange-600"}>
                                On Rest
                              </button>
                              <button type="button" onClick={() => GetDoctorChangeStatus(0)} class={(doctorStatus == 0 ? "bg-red-500" : "bg-gray-400") + " px-4 py-2 text-sm font-semibold text-white  border-gray-200 hover:bg-red-400 focus:z-10 focus:ring-2 focus:ring-red-500 active:bg-red-600 rounded-r-lg"}>
                                Offline
                              </button>
                            </p>
                          </div>
                        </li>
                        {fastNotesData.map(item =>
                          <li onClick={() => { setNote(item.note); setIsOpenPop(!isOpenPop) }} class="pl-2 px-1 py-5 hover:bg-gray-200 active:bg-green-300 cursor-pointer">
                            <div class="flex items-center space-x-2 min-w-0">
                              <div><FaDisease /></div>
                              <p class="text-gray-900 truncate ">
                                {item.note}
                              </p>
                            </div>
                          </li>
                        )}
                      </ul>
                    </div>
                  </div>
                </Card>
              </div>
            </>
            :
            <div className='w-full'>
              <Card isBorder={true} isBack={true} title={centerData && (centerData.centerName + " | " + moment(centerData.opdStartTime).format("LT") + "-" + moment(centerData.opdEndTime).format("LT"))}  >
                <h1 className='my-16 text-3xl text-center'>OPD Not Started Yet, Call Reception to Start OPD!</h1>
              </Card>
            </div>
        }
      </div>
      <WarningPopUp call={NextPatient} isOpen={isOpenPop} setIsOpen={setIsOpenPop} loding={lodingCrud} text={"Are you sure to call Next Patient?"} />
    </ContainerTwo>

  )
}